export const MAP_CONTAINER_STYLE = {
  width: '100%',
  height: '100%',
};

export const DEFAULT_CENTER = {
  lat: 37.566826,
  lng: 126.9786567,
};

// Airbnb-style clean map: light pastel tones, soft roads, parks & transit visible
export const MAP_STYLES: google.maps.MapTypeStyle[] = [
  // Land — very light warm gray
  { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#f2f1ec' }] },
  { featureType: 'landscape.man_made', elementType: 'geometry', stylers: [{ color: '#ebebeb' }] },
  // Water — soft sky blue
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#b8d9ed' }] },
  { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#7aaac4' }] },
  // Parks — clear light green
  { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#c8e6b8' }] },
  { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#5a8a50' }] },
  // Natural (mountains, forests)
  { featureType: 'landscape.natural', elementType: 'geometry', stylers: [{ color: '#d4e8c4' }] },
  // POI — hide most, show parks
  { featureType: 'poi', stylers: [{ visibility: 'off' }] },
  { featureType: 'poi.park', stylers: [{ visibility: 'simplified' }] },
  // Highways — soft tan/cream, numbers badge visible
  { featureType: 'road.highway', elementType: 'geometry.fill', stylers: [{ color: '#e8d9b0' }] },
  { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#d4c090' }, { weight: 0.5 }] },
  { featureType: 'road.highway', elementType: 'labels.text.fill', stylers: [{ color: '#666050' }] },
  { featureType: 'road.highway', elementType: 'labels.icon', stylers: [{ visibility: 'on' }] },
  // Arterial roads — light gray, visible
  { featureType: 'road.arterial', elementType: 'geometry.fill', stylers: [{ color: '#ffffff' }] },
  { featureType: 'road.arterial', elementType: 'geometry.stroke', stylers: [{ color: '#d8d5ce' }, { weight: 0.5 }] },
  { featureType: 'road.arterial', elementType: 'labels.text.fill', stylers: [{ color: '#999890' }] },
  { featureType: 'road.arterial', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  // Local roads — barely visible, no labels
  { featureType: 'road.local', elementType: 'geometry.fill', stylers: [{ color: '#f8f7f4' }] },
  { featureType: 'road.local', elementType: 'geometry.stroke', stylers: [{ color: '#e4e2dc' }, { weight: 0.3 }] },
  { featureType: 'road.local', elementType: 'labels', stylers: [{ visibility: 'off' }] },
  // Transit — subway lines simplified
  { featureType: 'transit.line', elementType: 'geometry', stylers: [{ visibility: 'simplified' }] },
  { featureType: 'transit.station', elementType: 'labels.text.fill', stylers: [{ color: '#8888aa' }] },
  { featureType: 'transit.station', elementType: 'labels.icon', stylers: [{ visibility: 'simplified' }] },
  // Administrative — district labels soft
  { featureType: 'administrative', elementType: 'labels.text.fill', stylers: [{ color: '#888884' }] },
  { featureType: 'administrative.land_parcel', stylers: [{ visibility: 'off' }] },
  { featureType: 'administrative.neighborhood', elementType: 'labels.text.fill', stylers: [{ color: '#aaaaaa' }] },
];

// 52x52 container with 44x44 circle (#FF7576) — equivalent to padding: 4px
export const CLUSTER_ICON_URL =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTIiIGhlaWdodD0iNTIiIHZpZXdCb3g9IjAgMCA1MiA1MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNTIiIGhlaWdodD0iNTIiIHJ4PSIyNiIgZmlsbD0iI0ZGMkQyRSIgZmlsbC1vcGFjaXR5PSIwLjI0Ii8+PGNpcmNsZSBjeD0iMjYiIGN5PSIyNiIgcj0iMjIiIGZpbGw9IiNGRjc1NzYiLz48L3N2Zz4=';

export const CLUSTER_STYLES = [
  {
    url: CLUSTER_ICON_URL,
    width: 52,
    height: 52,
    anchor: [26, 26] as [number, number],
    textColor: '#FFFFFF',
    textSize: 13,
  },
];
